import { useState, useEffect, useRef } from 'react'
import styles from './MobileMultiCarousel.module.scss'
import { StarIcon } from '@heroicons/react/24/outline'
import { ChevronDownIcon } from '@heroicons/react/24/solid'

const MobileMultiCarousel = ({ interval = 3000 }) => {
	const [index, setIndex] = useState(6)
	const [isTransition, setIsTransition] = useState(true)
	const trackRef = useRef(null)

	const items = [
		{
			imageSrc: '/images/profileImage1.png',
			wordProfileTopLayer: '투어 / 박캐디 / 3년 / 그린...',
			wordProfileMiddleLayer: '2024 코리아 챌린지 투어 / TOP15',
			wordProfileBottomLayer: '주급',
			wordProfileBottomLayerValue: '2,000,000원',
		},
		{
			imageSrc: '/images/profileImage2.png',
			wordProfileTopLayer: '프로 / 심프로 / 9년 / 이글...',
			wordProfileMiddleLayer: '2023 마스터스 아시아 예선 / CUT 통과',
			wordProfileBottomLayer: '주급',
			wordProfileBottomLayerValue: '1,700,000원',
		},
		{
			imageSrc: '/images/profileImage3.png',
			wordProfileTopLayer: '캐디 / 박캐디 / 5년 / 갤럭...',
			wordProfileMiddleLayer: '2023 제 1회 스카이 레이크 오픈 / TOP 10',
			wordProfileBottomLayer: '주급',
			wordProfileBottomLayerValue: '1,800,000원',
		},
		{
			imageSrc: '/images/profileImage4.png',
			wordProfileTopLayer: '프로 / 김프로 / 3년 / 무소속',
			wordProfileMiddleLayer: '2024 한국 내셔널 챔피언십 / 전략적 코스...',
			wordProfileBottomLayer: '주급',
			wordProfileBottomLayerValue: '1,500,000원',
		},
		{
			imageSrc: '/images/profileImage5.png',
			wordProfileTopLayer: '투어 / 이캐디 / 3년 / 나이...',
			wordProfileMiddleLayer: 'LPGA 투어 시드전 / 전략적 코스 매니지먼트',
			wordProfileBottomLayer: '주급',
			wordProfileBottomLayerValue: '2,500,000원',
		},
	]

	// const extended = [
	// 	items[3],
	// 	items[4], // 4, 5
	// 	...items, // 1,2,3,4,5
	// 	items[0],
	// 	items[1], // 1,2
	// ]

	const extended = [
		...items.slice(-4), // 3개 복제
		...items,
		...items.slice(0, 4), // 3개 복제
	]

	useEffect(() => {
		const timer = setInterval(() => {
			setIndex((prev) => prev + 1)
		}, interval)
		return () => clearInterval(timer)
	}, [interval])

	// useEffect(() => {
	// 	const timer = setInterval(() => {
	// 		setIndex((prev) => {
	// 			if (prev === 10) {
	// 				// reset 직전 처리
	// 				setIsTransition(false)
	// 				return 6
	// 			}
	// 			setIsTransition(true)
	// 			return prev + 1
	// 		})
	// 	}, interval)

	// 	return () => clearInterval(timer)
	// }, [interval])

	// useEffect(() => {
	// 	if (index === items.length + 2) {
	// 		// ✅ 마지막 슬라이드 넘어가면 부드럽게 리셋
	// 		setTimeout(() => {
	// 			setIsTransition(false) // 애니메이션 잠깐 OFF
	// 			setIndex(4)
	// 			requestAnimationFrame(() => {
	// 				setIsTransition(true)
	// 			})
	// 		}, 400) // transition 시간과 동일
	// 	} else {
	// 		setIsTransition(true)
	// 	}
	// }, [index, items.length])

	useEffect(() => {
		if (index === 11) {
			setIsTransition(false) // ✅ transition 먼저 OFF
			setIndex(5) // ✅ 바로 순간 이동
			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					setIsTransition(true) // ✅ 두 프레임 후 다시 ON
				})
			})
		}
	}, [index, items.length])

	// useEffect(() => {
	// 	if (index === 11) {
	// 		setIsTransition(false)
	// 		setIndex(5)
	// 		setTimeout(() => {
	// 			setIsTransition(true)
	// 		}, 0) // ✅ 프레임 미루기 최소화
	// 	}
	// }, [index])

	const ITEM_WIDTH = 296
	const GAP = 20
	const MOVE = ITEM_WIDTH + GAP

	return (
		<div className={styles.mcContainer}>
			<div
				className={styles.mcTrack}
				style={{
					transform: `translateX(calc(50vw - ${ITEM_WIDTH / 2}px - ${index * MOVE}px))`,
					transition: isTransition ? 'transform 0.4s ease' : 'none',
				}}>
				{extended.map((item, i) => (
					<div key={i} className={styles.profileCard}>
						<div className={styles.topLayer}>
							<div className={styles.topLayerBox}>
								가능대회목록
								<div className={styles.topLayerBoxRight}>
									프로필상세
									<StarIcon className={styles.star} />
								</div>
							</div>
						</div>
						<div className={styles.bottomLayer}>
							<div className={styles.mainProfileBox}>
								<div className={styles.mainProfileTop}>
									<img src={item.imageSrc} className={styles.cardImage} />
									<div className={styles.wordProfile}>
										<div className={styles.wordProfileTopLayer}>
											{item.wordProfileTopLayer}
										</div>
										<div className={styles.wordProfileMiddleLayer}>
											{item.wordProfileMiddleLayer}
										</div>
										{/* <div className={styles.wordProfileBottomLayer}>
										<div>주급</div>
										<div>{item.wordProfileBottomLayerValue}</div>
									</div> */}
									</div>
								</div>

								<div className={styles.wordProfileBottomLayer}>
									<div className={styles.wordProfileBottomLayerItem}>주급</div>
									<div className={styles.wordProfileBottomLayerItem}>
										{item.wordProfileBottomLayerValue}
									</div>
								</div>
							</div>
							<ChevronDownIcon className={styles.chevronDownIcon} />
						</div>
					</div>
				))}
			</div>
			<div className={styles.centerEmphasize}></div>
			<div className={styles.centerEmphasizeButton}>제안하기</div>
		</div>
	)
}

export default MobileMultiCarousel
